import { VatMode } from '@crm/shared'

/** Метка «НДС сверху» в шапке деталей КП (docs/features/kp-vat-mode.md); у КП «С НДС» — ничего. */
export function KpVatBadge({ vatMode }: { vatMode?: VatMode }) {
  if (vatMode !== VatMode.ON_TOP) return null
  return (
    <span
      className="ml-2 rounded bg-amber-100 px-1.5 py-0.5 text-amber-700"
      title="Цены в файле КП — без НДС, НДС 22% начислен сверху. В таблице ниже цены с НДС."
    >
      НДС сверху
    </span>
  )
}
